// store/index.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
 state: {
  cameraMode: 'SHOOT_PHOTO',
  isShootingPhoto: false,
  canStartShootingPhoto: true,
  shootPhotoMode: 'SINGLE',
  isShootingCompleted: true,
  recordingState: 'RECORDING_STOPPED',
  recordingTime: '00:00',
  takeOffWidget: {
   takeOffLandingState: 'DISCONNECTED', // all possible aircraft states, e.g. ready to land, auto landing, etc.
   takeOffStartSucceeded: false, // todo: we don't need  to store 1 time events?
   precisionTakeOffStartSucceeded: false,
   takeOffStartFailed: false,
   precisionTakeOffStartFailed: false,
   landingStartSucceeded: false,
   landingStartFailed: false,
   landingConfirmSucceeded: false,
   landingConfirmFailed: false,
   landingCancelSucceeded: false,
   landingCancelFailed: false,
  },
  returnHomeWidget: {
   returnHomeState: 'RETURN_HOME_DISABLED',
  },
  featureStatus: {
   isGimbalCameraControlEnabled: false,
   isDroneControlEnabled: false,
   isTakePictureEnabled: false,
   degradationPreference: 'Balanced',
   isDegradationPreferenceEnabled: false
  }
 },
 getters: {
  isRecording: state => {
    return state.recordingState === 'RECORDING_IN_PROGRESS'
  },
  isCameraModePhoto: state => {
   return state.cameraMode === 'SHOOT_PHOTO'
  },
  isFlying: state => {
   return state.takeOffWidget.takeOffLandingState === 'READY_TO_LAND'
  },
  isLanding: state => {
   return state.takeOffWidget.takeOffLandingState === 'AUTO_LANDING' || state.takeOffWidget.takeOffLandingState === 'WAITING_FOR_LANDING_CONFIRMATION'
  },
  isReturningHome: state => {
   return state.returnHomeWidget.returnHomeState === 'RETURNING_TO_HOME' || state.returnHomeWidget.returnHomeState === 'FORCED_RETURNING_TO_HOME'
  }
 },
 mutations: {
  setCameraMode (state, value) {
   state.cameraMode = value
  },
  setTakeOffLandingState (state, value) {
   state.takeOffWidget.takeOffLandingState = value
  },
  setTakeOffStartSucceeded (state, value) {
   state.takeOffWidget.takeOffStartSucceeded = value
  },
  setReturnHomeState (state, value) {
   state.returnHomeWidget.returnHomeState = value
  },
  setIsShootingPhoto (state, value) {
   state.isShootingPhoto = value
  },
  setCanStartShootingPhoto (state, value) {
   state.canStartShootingPhoto = value;
  },
  setShootPhotoMode (state, value) {
   state.shootPhotoMode = value;
  },
  setIsShootingCompleted (state, value) {
   state.isShootingCompleted = value;
  },
  setRecordingState (state, value) {
   state.recordingState = value;
  },
  setRecordingTime (state, value) {
   state.recordingTime = value;
  },
  setFeatureStatus (state, value) {
   state.featureStatus = value;
  },
  setDegradationPreference (state, value) {
   state.featureStatus.degradationPreference = value;
  },
 },
 actions: {}
});
